import Controls from '../../components/Controls/Controls';
export default Controls;
